<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 md6 offset-md3 lg4 offset-lg4 xl4 offset-xl4>
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">Login</h3>
                <v-form @submit="login">
                  <v-container>
                    <v-layout row wrap>

                      <v-flex xs12>
                        <v-alert class="error" v-model="loginFailed">Die Kombination aus Benutzername und Passwort ist fehlerhaft.</v-alert>
                      </v-flex>
                      <v-flex xs12><v-text-field label="Benutzername" v-model="username"></v-text-field></v-flex>
                      <v-flex xs12><v-text-field label="Passwort" type="password" v-model="password"></v-text-field></v-flex>
                      <v-flex xs12><v-select label="Veranstaltung" :items="sportabelEvents" :item-text="'title'" :item-value="'token'" v-model="event"></v-select></v-flex>
                      <v-flex xs12 class="text-xs-center"><v-btn @click="login">Login</v-btn></v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </div>
            </v-card-title>

            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

  export default {
    components: {},
    computed: {
      sportabelEvents () {
        return this.$store.state.sportabelEvents
      }
    },
    data: function () {
      return {
        loginFailed: false,
        username: '',
        password: '',
        event: null,
      }
    },
    methods: {
      login: function () {
        let username = this.username
        let password = this.password
        let event = this.event
        localStorage.setItem('event', this.event)
        this.$store.dispatch('login', { username, password, event })
                .then(() => this.$router.push('/home'))
                .catch(() => this.loginFailed = true)
      }
    },
    created() {
      const event = localStorage.getItem('event')
      if (event !== undefined) this.event = event
    }
  }
</script>
